/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum NotificationAction {
	NOTIFY = 'NOTIFY',
	DONT_NOTIFY = 'DONT_NOTIFY',
}

export interface ContentMention {
	notificationAction: NotificationAction;
	mentionedUserAccountId: string;
	mentionLocalId?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateContentMentionNotificationAction
// ====================================================

export interface CreateContentMentionNotificationAction_createContentMentionNotificationAction_errors {
	message: string | null;
}

export interface CreateContentMentionNotificationAction_createContentMentionNotificationAction {
	contentId: string;
	success: boolean;
	errors:
		| CreateContentMentionNotificationAction_createContentMentionNotificationAction_errors[]
		| null;
}

export interface CreateContentMentionNotificationAction {
	createContentMentionNotificationAction: CreateContentMentionNotificationAction_createContentMentionNotificationAction;
}

export interface CreateContentMentionNotificationActionVariables {
	contentId: string;
	mentions: (ContentMention | null)[];
}
